import { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import { RootState } from '../store/store';
import companyService from '../services/company/company.service';

export const useCompanyData = () => {
  const { user } = useSelector((state: RootState) => state.auth);
  const [companyData, setCompanyData] = useState<any>(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    const fetchCompanyData = async () => {
      if (!user?.companyId) return;
      
      try {
        setLoading(true);
        setError(null);
        const company = await companyService.getCompanyById(user.companyId);
        setCompanyData(company);
      } catch (err: any) {
        setError(err.message || 'Company bilgileri alınamadı');
      } finally {
        setLoading(false);
      }
    };

    fetchCompanyData();
  }, [user?.companyId]);

  return { companyData, loading, error };
}; 